import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import 'assets/css/MiniCalendar.css';

const MiniCalendar = ({ value, onChange, width, tileClassName, tileContent, onActiveStartDateChange, maxDate }) => {
  const handleDateChange = (newDate) => {
    const localDate = new Date(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      0,
      0,
      0,
      0
    );

    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');

    // Format: YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;

    onChange(localDate, formattedDate);
  };

  return (
    <div
      className={`flex ${
        width ? `w-[${width}]` : 'w-full md:w-[320px]'
      } h-full max-w-full flex-col rounded-[20px] bg-white px-3 py-4 dark:border dark:!border-white/10 dark:!bg-navy-800`}
    >
      <Calendar
        onChange={handleDateChange}
        value={value}
        prevLabel={<MdChevronLeft className="ml-1 h-6 w-6" />}
        nextLabel={<MdChevronRight className="ml-1 h-6 w-6" />}
        view={'month'}
        tileClassName={tileClassName}
        tileContent={tileContent}
        onActiveStartDateChange={onActiveStartDateChange}
        maxDate={maxDate}
      />
    </div>
  );
};

export default MiniCalendar;
